import React, { useState } from 'react';
import Icon from '../AppIcon';

const SavedFilters = ({ filters, onApply, onDelete, onSave, currentFilters }) => {
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [filterName, setFilterName] = useState('');

  const handleSave = () => {
    if (filterName?.trim()) {
      onSave(filterName, currentFilters);
      setFilterName('');
      setShowSaveModal(false);
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6 shadow-sm">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Icon name="Bookmark" size={20} color="#3b82f6" />
          Saved Filters
        </h3>
        <button
          onClick={() => setShowSaveModal(true)}
          className="px-3 py-1.5 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors"
        >
          Save Current
        </button>
      </div>

      {filters?.length === 0 ? (
        <p className="text-sm text-gray-500 text-center py-4">No saved filters yet</p>
      ) : (
        <div className="space-y-2">
          {filters?.map((filter) => (
            <div
              key={filter?.id}
              className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <button
                onClick={() => onApply(filter?.filters)}
                className="flex-1 text-left text-sm font-medium text-gray-700 hover:text-blue-600"
              >
                {filter?.name}
              </button>
              <button
                onClick={() => onDelete(filter?.id)}
                className="p-1 hover:bg-red-100 rounded transition-colors"
              >
                <Icon name="Trash2" size={16} color="#EF4444" />
              </button>
            </div>
          ))}
        </div>
      )}

      {showSaveModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 max-w-md w-full">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Save Filter</h3>
            <input
              type="text"
              value={filterName}
              onChange={(e) => setFilterName(e?.target?.value)}
              placeholder="Filter Name"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <div className="flex gap-3">
              <button
                onClick={() => setShowSaveModal(false)}
                className="flex-1 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleSave}
                className="flex-1 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SavedFilters;